import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import Input from "components/Input";
import { useTranslation } from "react-i18next";

const ClientAdditionalAccordion: FC<Props> = ({
  showed,
  data,
  setData,
  handleAdd,
}) => {
  const { t } = useTranslation();

  const handleInputChange = (
    key: string,
    value: string | number,
    index: number = 0
  ) => {
    const updatedData = { ...data };
    //@ts-ignore
    if (Array.isArray(updatedData[key])) {
      //@ts-ignore
      updatedData[key][index] = value;
    } else {
      //@ts-ignore
      updatedData[key] = value;
    }
    setData(updatedData);
  };

  const contentRef = useRef<HTMLDivElement>(null);

  const [height, setHeight] = useState("0px");

  useEffect(() => {
    if (contentRef.current) {
      setHeight(showed ? `${contentRef.current.scrollHeight + 100}px` : "0px");
    }
  }, [showed]);

  // console.log(address)
  return (
    <div
      ref={contentRef}
      style={{
        height: height,
      }}
      className={styles.wrapper}
    >
      <div className={styles.line}></div>
      <div key={0} className={styles.address}>
        <Input
          onChange={(text) =>
            handleInputChange(
              "addresses",
              { ...data.addresses[0], street: text },
              0
            )
          }
          value={data.addresses[0].street}
          label={t("forms.street")}
          placeholder={t("forms.street")}
        />
        <div className={styles.box}>
          <Input
            onChange={(text) =>
              handleInputChange(
                "addresses",
                { ...data.addresses[0], zipCode: text },
                0
              )
            }
            value={data.addresses[0].zipCode}
            label={t("forms.zipCode")}
            placeholder={t("forms.zipCode")}
            isCode
          />
          <Input
            onChange={(text) =>
              handleInputChange(
                "addresses",
                { ...data.addresses[0], city: text },
                0
              )
            }
            value={data.addresses[0].city}
            label={t("common.city")}
            placeholder={t("common.city")}
          />
        </div>
      </div>{" "}
      <Input
        onChange={(text) => handleInputChange("bank", text, 0)}
        value={data.bank[0]}
        label={t("forms.accountNumberShort")}
        isBank
        placeholder={t("forms.accountNumberShort")}
      />
      <Input
        onChange={(text) => handleInputChange("regon", text, 0)}
        value={data.regon}
        label={t("forms.regon")}
        placeholder={t("forms.regon")}
      />
      <Input
        onChange={(text) => handleInputChange("EAddresses", text, 0)}
        value={data.EAddresses[0]}
        label={t("forms.eDelivery")}
        placeholder={t("forms.eDelivery")}
      />
    </div>
  );
};

export default ClientAdditionalAccordion;
